<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div
              class="row p-0 align-items-center d-flex justify-content-between"
            >
              <div class="col-auto mt-lg-4 mt-md-4 ms-lg-5 ms-md-5">
                <h4 class="d-none d-sm-block">Education Fee Payments</h4>
                <h4 class="rental-heading d-block d-sm-none">Education Fee</h4>
              </div>

              <div class="col-auto me-lg-5 d-flex education-btn">
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary me-2"
                  @click="Addschool()"
                >
                  Add School
                </llp-button>
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary d-none d-sm-block new-btn"
                  @click="BackToServices()"
                >
                  Back To Services
                </llp-button>
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary d-block d-sm-none new-btn"
                  @click="BackToServices()"
                >
                  Go Back
                </llp-button>
              </div>
            </div>
            <div class="row m-4">
              <!-- State Dropdown -->
              <div class="col-lg-3 col-md-6 col-sm-6">
                <llp-label id="state" :aria-label="'State'">State:</llp-label>
                <Dropdown
                  v-model="selectedState"
                  :options="stateList"
                  optionLabel="name"
                  placeholder="Select your state"
                  class="form-control select-dropdown bbps-service-dropdown"
                  @change="onStateChange"
                  :loading="showOperatorsSpinner"
                  filter
                  filterBy="name"
                >
                  <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center">
                      <div class="bbps-options">{{ slotProps.value.name }}</div>
                    </div>
                    <span v-else>{{ slotProps.placeholder }}</span>
                  </template>

                  <template #option="slotProps">
                    <div class="flex align-items-center">
                      <div>{{ slotProps.option.name }}</div>
                    </div>
                  </template>
                </Dropdown>
              </div>

              <!-- City Dropdown -->
              <div v-if="selectedState" class="col-lg-3 col-md-6 col-sm-6">
                <llp-label id="city" :aria-label="'City'">City:</llp-label>
                <Dropdown
                  v-model="selectCity"
                  :options="cityList"
                  optionLabel="name"
                  placeholder="Select your city"
                  class="form-control select-dropdown bbps-service-dropdown"
                  @change="onCityChange"
                  :loading="showOperatorsSpinner"
                  filter
                  filterBy="name"
                >
                  <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center">
                      <div class="bbps-options">{{ slotProps.value.name }}</div>
                    </div>
                    <span v-else>{{ slotProps.placeholder }}</span>
                  </template>

                  <template #option="slotProps">
                    <div class="flex align-items-center">
                      <div>{{ slotProps.option.name }}</div>
                    </div>
                  </template>
                </Dropdown>
              </div>

              <div v-if="selectCity" class="col-lg-3 col-md-6 col-sm-6">
                <llp-label id="school" :aria-label="'School'"
                  >Schools:</llp-label
                >
                <Dropdown
                  v-model="selectedSchool"
                  :options="schools"
                  optionLabel="school_name"
                  placeholder="Please select a school"
                  class="form-control select-dropdown bbps-service-dropdown"
                  @change="selectSchool(selectedSchool)"
                  :loading="showOperatorsSpinner"
                  filter
                  filterBy="school_name"
                >
                  <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center">
                      <div class="bbps-options">
                        {{ slotProps.value.school_name }}
                      </div>
                      <!-- Updated key -->
                    </div>
                    <span v-else>{{ slotProps.placeholder }}</span>
                  </template>

                  <template #option="slotProps">
                    <div class="flex align-items-center">
                      <div>{{ slotProps.option.school_name }}</div>
                      <!-- Updated key -->
                    </div>
                  </template>
                </Dropdown>
              </div>
              <!-- Row showing selected data -->
              <div v-if="selectedSchool" class="row mt-4">
                <div class="col-lg-10 col-md-12 col-sm-12 view-student-details">
                  <div class="card p-4">
                    <h5>Student Details:</h5>
                    <div class="row">
                      <div class="col-lg-5 col-md-6 col-sm-12">
                        <llp-label id="stateId" :aria-label="'State'"
                          >State:</llp-label
                        >
                        <llp-input
                          id="stateInput"
                          v-model="selectedData.state"
                          class="w-100"
                          autocomplete="off"
                          disabled
                        ></llp-input>
                      </div>
                      <div class="col-lg-5 col-md-6 col-sm-12">
                        <llp-label id="cityId" :aria-label="'City'"
                          >City:</llp-label
                        >
                        <llp-input
                          id="cityInput"
                          v-model="selectedData.city"
                          class="w-100"
                          autocomplete="off"
                          disabled
                        ></llp-input>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-lg-5 col-md-6 col-sm-12">
                        <llp-label id="schoolId" :aria-label="'School'"
                          >School:</llp-label
                        >
                        <llp-input
                          id="schoolInput"
                          v-model="selectedData.school"
                          class="w-100"
                          autocomplete="off"
                          disabled
                        ></llp-input>
                      </div>
                      <div class="col-lg-5 col-md-6 col-sm-12">
                        <llp-label id="uniqueId" :aria-label="'Admission No'">
                          Student Admission Number:
                        </llp-label>
                        <llp-input
                          id="UniqueInput"
                          v-model="uniqueId"
                          placeHolder="Enter your student admission number"
                          class="w-100"
                          autocomplete="off"
                          :errors="validator.uniqueId.$errors"
                        ></llp-input>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-lg-5 col-md-6 col-sm-12">
                        <llp-label id="Name" :aria-label="'Name'">
                          Student Name:
                        </llp-label>
                        <llp-input
                          id="StudentNameId"
                          v-model="Name"
                          class="w-100"
                          autocomplete="off"
                          :errors="validator.Name.$errors"
                        ></llp-input>
                      </div>
                      <div class="col-lg-5 col-md-6 col-sm-12">
                        <llp-label id="amountId" :aria-label="'Amount'">
                          Amount:
                        </llp-label>
                        <llp-input
                          id="UniqueInput"
                          v-model="Amount"
                          class="w-100"
                          autocomplete="off"
                          :errors="validator.Amount.$errors"
                        ></llp-input>
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-6 col-sm-12">
                      <llp-button
                        classNames="btn-secondary text-white new-btn"
                        :load-spinner="payloadSpinner"
                        type="submit"
                        @click:button="fetchPaymentMethods()"
                      >
                        Proceed To Pay
                      </llp-button>
                    </div>
                  </div>
                </div>
              </div>
              <Dialog
                v-model:visible="showPaymentDialog"
                header="Select Payment Method"
                modal
                :style="{ width: '90%', maxWidth: '45rem' }"
                :breakpoints="{ '960px': '75vw', '641px': '90vw' }"
                 @hide="onHideDialog"
              >
                <div v-if="loadingSpinner" class="loader-overlay">
                  <div class="spinner"></div>
                </div>
                <span class="text-surface-500 dark:text-surface-400 block">
                  Choose how you'd like to pay:
                </span>

                <div class="row mt-2">
                  <div
                    class="col-6 mb-2"
                    v-for="method in paymentMethods"
                    :key="method.id"
                  >
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        :id="method.id"
                        :value="method.value"
                        v-model="selectedPaymentMethod"
                        name="paymentOption"
                          @change="handlePaymentMethodChange(method.value)"
                      />
                      <label class="form-check-label ms-2" :for="method.id">
                        {{ method.name }}
                      </label>
                    </div>
                  </div>
                </div>

                <div v-if="selectedPaymentMethod === 'Credit Card/Debit Card'">
                  <h5>Card details:</h5>
                  <div class="row">
                    <div class="mb-2 col-lg-6 col-md-6 col-sm-12">
                      <llp-label>Card Number:</llp-label>
                      <llp-input
                        v-model="cardDetails.cardNumber"
                        class="w-100 mb-2"
                        placeholder="Enter card number"
                        :errors="validator.cardDetails.cardNumber.$errors"
                       @input="formatCardNumber($event)"
                      ></llp-input>
                    </div>
                  </div>

                  <div class="row">
                    <div class="mb-2 col-lg-6 col-md-6 col-sm-6">
                      <llp-label>Name on card</llp-label>
                      <llp-input
                        v-model="cardDetails.cardHolderName"
                        class="w-100 mb-2"
                        :errors="validator.cardDetails.cardHolderName.$errors"
                      />
                    </div>
                  </div>
                  
                </div>
            <div class="row" v-if="this.paymentCharges">
              <div class="col-6">
                <p class="mb-1"><strong>Amount:</strong></p>
                <p class="mb-3"><strong>Service Charge:</strong></p>
              </div>
              <div class="col-6">
                <p class="mb-1">₹{{ paymentCharges.base_amount }}</p>
                <p class="mb-3">₹{{ paymentCharges.charge_amount }}</p>
              </div>
                    </div>
                <div class="flex justify-end gap-2">
                  <button class="btn btn-secondary" @click="PayAmount">
                                     Pay Now <span v-if="paymentCharges?.total_payable">(₹{{ paymentCharges.total_payable }})</span>

                  </button>
                </div>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import Dropdown from "primevue/dropdown";
import { useVuelidate } from "@vuelidate/core";
// import ErrorService from "../../../services/error.service";
import NetworkService from "@/services/network.service";
import { helpers, required } from "@vuelidate/validators";
import Dialog from "primevue/dialog";
import _ from 'lodash';

export default {
  setup() {
    const validator = useVuelidate();
    return { validator };
  },

  components: {
    Dropdown,
    Dialog,
  },
  data() {
    return {
      showOperatorsSpinner: false,
      selectedState: null,
      selectCity: null,
      selectedSchool: null,
      userId: localStorage.getItem("User_id"),
      role_id:localStorage.getItem('role_id'),
      selectedData: {
        state: "",
        city: "",
        school: "",
      },
      uniqueId: "",
      Amount: "",
      Name: "",
        paymentCharges: null,
      loadingSpinner: false,
      serviceId: this.$route.params.serviceId,
      stateList: [],
      cityList: [],
      schools: [],
      payloadSpinner: false,
      showPaymentDialog: false,
      student_data: "",
      paymentMethods: [],
      selectedPaymentMethod: "",
       lastCardDigits: "",
        lastCardHolderName: "",
        debouncedFetchCharges: null,
      cardDetails: {
        cardNumber: "",
        cardHolderName: "",
      },
    };
  },
   created() {
    this.debouncedFetchCharges = _.debounce(this.fetchPaymentCharges, 2000);
  },
  watch: {
    'cardDetails.cardNumber'() {
    this.tryFetchCharges();
  },
  'cardDetails.cardHolderName'() {
    this.tryFetchCharges();
  }
  },
 beforeUnmount() {
    if (this.debouncedFetchCharges) {
      this.debouncedFetchCharges.cancel();
    }
  },
  validations() {
    return {
      uniqueId: {
        required: helpers.withMessage(
          "Student admission number is required.",
          required
        ),
      },
      Amount: {
        required: helpers.withMessage("Amount is required.", required),
         numericOnly: helpers.withMessage(
          "Amount must be a valid number.",
          (value) => /^(\d+(\.\d{1,2})?)$/.test(value)
        ),
      },
      Name: {
        required: helpers.withMessage("Student name is required.", required),
         alphaOnly: helpers.withMessage(
          "Name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
    cardDetails: {
         cardNumber: {
      required: helpers.withMessage("Card number is required.", required),
      validLength: helpers.withMessage(
        "Please enter exactly 16 digits",
        value => {
          if (!value) return true;
          const digits = value.replace(/\D/g, '');
          return digits.length === 16;
        }
      ),
      maxLength: helpers.withMessage(
        "Maximum 16 digits allowed",
        value => {
          if (!value) return true;
          const digits = value.replace(/\D/g, '');
          return digits.length <= 16;
        }
      )
    },
        cardHolderName: {
          required: helpers.withMessage(
            "Card holder name is required.",
            required
          ),
        },
      },

    };
  },
  mounted() {
    this.fetchingStates();
    const script = document.createElement("script");
    script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    script.async = true;
    document.head.appendChild(script);
  },
  methods: {
   formatCardNumber(event) {
  let value = event.target?.value || event; // Handle both direct value and event
  let digits = value.toString().replace(/\D/g, '');
  this.cardDetails.cardNumber = digits.replace(/(\d{4})(?=\d)/g, '$1 ');
   this.validator.cardDetails.cardNumber.$touch();
  return this.cardDetails.cardNumber; 
},
 tryFetchCharges() {
  if (this.selectedPaymentMethod !== 'Credit Card/Debit Card') return;
  const cleanNumber = this.cardDetails.cardNumber.replace(/\D/g, '');
  const holderName = this.cardDetails.cardHolderName?.trim();
  if (cleanNumber.length === 16 && holderName) {
    if (this.lastCardDigits !== cleanNumber || this.lastCardHolderName !== holderName) {
      this.lastCardDigits = cleanNumber;
      this.lastCardHolderName = holderName;
      this.debouncedFetchCharges('Credit Card/Debit Card', {
        card_number: cleanNumber,
      });
    }
  } else {
    this.paymentCharges = null;
  }
},
// formatExpiryDate(event) {
//   let value = event.target?.value || event;
//   let cleaned = value.toString().replace(/\D/g, '');
//   if (cleaned.length > 2) {
//     this.cardDetails.expiry = cleaned.substring(0, 2) + '/' + cleaned.substring(2, 4);
//   } else {
//     this.cardDetails.expiry = cleaned;
//   }
//         this.validator.cardDetails.expiry.$touch();

//   return this.cardDetails.expiry;
// },

// formatCVV(event) {
//   let value = event.target?.value || event;
//   this.cardDetails.cvv = value.toString().replace(/\D/g, '').substring(0, 3);
//   this.validator.cardDetails.cvv.$touch();
//   return this.cardDetails.cvv;
// },
onHideDialog() {
    NetworkService.resetPaymentDialog(this);
  },
    BackToServices() {
      this.$router.push(`/services`);
    },
    Addschool() {
      this.$router.push({
        name: "AddSchool",
        params: { serviceId: this.serviceId },
      });
    },
    async fetchingStates() {
      try {
        const stateResponse = await NetworkService.get("/get-states-list-by-schoolwise");
        this.stateList = stateResponse.states;
      } catch (error) {
        this.$refs.toast.show("Unable to fetching the states", "error");
      }
    },
    async fetchingCities(stateId) {
      try {
        const cityResponse = await NetworkService.get(
          `/get-cities-list-by-schoolwise/${stateId}`
        );
        this.cityList = cityResponse.cities;
      } catch (error) {
        this.$refs.toast.show("Unable to fetching the cities", "error");
      }
    },
    async fetchingSchools(stateId, cityId) {
      try {
        const schoolResponse = await NetworkService.get(
          `/get-schools-list/${stateId}/${cityId}`
        );
        this.schools = schoolResponse.schools;
      } catch (error) {
        this.$refs.toast.show("Unable to fetching the schools", "error");
      }
    },
    onStateChange() {
      if (this.selectedState) {
        this.selectedData.state = this.selectedState.name;
        this.fetchingCities(this.selectedState.id);
        this.selectCity = null;
        this.cityList = [];
        this.schools = [];
      }
    },
    onCityChange() {
      if (this.selectCity) {
        this.selectedData.city = this.selectCity.name;
        this.fetchingSchools(this.selectedState.id, this.selectCity.id);
         this.selectedSchool = null;
         this.schools = [];
      }
    },
    selectSchool(school) {
      this.selectedData.school = school.school_name;
    },

    async fetchPaymentMethods() {
      const isValid = await Promise.all([
        this.validator.uniqueId.$validate(),
        this.validator.Amount.$validate(),
        this.validator.Name.$validate(),
      ]);

      if (isValid.includes(false)) return;
      this.payloadSpinner = true;
      try {
        this.loadingSpinner = true;
        this.showPaymentDialog = true;
         this.paymentMethods = await NetworkService.getPaymentMethods();
           this.payloadSpinner = false;
      if (this.paymentMethods.length === 0) {
        this.$refs.toast.show("No payment methods available", "warning");
      }
      } catch (error) { 
      this.$refs.toast.show("Unable to fetch the payment methods", "error");
    } finally {
      this.loadingSpinner = false;
    }
    },
    
 handlePaymentMethodChange(methodValue) {
    this.selectedPaymentMethod = methodValue;
   this.paymentCharges = null;
   this.cardDetails.cardNumber = '';
    this.cardDetails.cardHolderName = '';
     if (this.validator?.cardDetails?.cardNumber) {
    this.validator.cardDetails.cardNumber.$reset();
  }
  if (this.validator?.cardDetails?.cardHolderName) {
    this.validator.cardDetails.cardHolderName.$reset();
  }
   if (methodValue !== 'Credit Card/Debit Card') {
    this.fetchPaymentCharges(methodValue);
  }
  },
  async fetchPaymentCharges(methodValue,extra ={}) {
     this.debouncedFetchCharges.cancel();
    if (!methodValue) return; 
    this.loadingCharges = true;
    this.loadingSpinner = true;
    try {
      const method = this.paymentMethods.find(m => m.value === methodValue);
      if (!method) {
        throw new Error('Payment method not found');
      }
  const payload = {
        user_id: this.userId,
        method_type: methodValue,
        base_amount: this.Amount,
        ...extra
      }
     const  response = await NetworkService.getPaymentCharges(method.id,this.role_id,payload);
     if (response.success === false) {
          this.$refs.toast.show(
            response.message || 'Unable to fetch payment charges',
            'error'
          );
          return;
        }
        this.paymentCharges = response;
         this.loadingSpinner = false;
      } catch (err) {
        const msg =
          err?.response?.data?.message || err.message || 'Failed to fetch charges';
        this.$refs.toast.show(msg, 'error');
    } finally {
      this.loadingCharges = false;
      this.loadingSpinner = false;
    }
  },
    async PayAmount() {
      if (!this.selectedPaymentMethod) {
        this.$refs.toast.show("Please select a payment method", "error");
        return;
      }

      if (this.selectedPaymentMethod === "Credit Card/Debit Card") {
        const isValid = await this.validator.$validate();
        if (!isValid) return;
      }
      try {
        // Step 1: Store Student Details First
        const studentPayload = {
          school_id: this.selectedSchool?.id,
          state_id: this.selectedState?.id,
          city_id: this.selectCity?.id,
          student_administarion_number: this.uniqueId,
          amount: this.Amount,
          student_name: this.Name,
        };

        const studentResponse = await NetworkService.post(
          "/store-student-details",
          studentPayload
        );
        this.student_data = studentResponse.data;
        if (!studentResponse.data?.status) {
          this.$refs.toast.show("Failed to store student details.", "error");
          return;
        }

        // Step 2: Proceed to Payment
        const selectedMethod = this.paymentMethods.find(
          (method) => method.value === this.selectedPaymentMethod
        );
        const paymentDetails = {
          user_id: this.userId,
          base_amount: this.Amount,
          service_id: this.serviceId,
          student_name: `${this.Name} (${this.uniqueId})`,
          name: this.student_data.school_data?.school_name,
          account_number: this.student_data.account_number,
          account_holder_name: this.student_data.account_holder_name,
          bank_name: this.student_data.bank_name,
          bank_branch: this.student_data.bank_branch,
          ifsc_code: this.student_data.ifsc_code,
          beneficiary_id: this.student_data.school_data?.beneficiary_id,
          payment_method_id: selectedMethod.id,
          mobile: this.student_data.school_data?.mobile || null,
          charge_amount:this.paymentCharges.charge_amount,
          amount:this.paymentCharges.total_payable,
          method_type:this.selectedPaymentMethod,
          charge_percent:this.paymentCharges.charge_percent
        };
        this.payloadSpinner = false;
        const result = await NetworkService.PaymentService.initiate(
          `get-payment-gateways-for-pay`,
          selectedMethod.id,
          paymentDetails
        );
const paymentSessionId = result?.order?.data?.payment_session_id;

        if (paymentSessionId) {
          const cashfreeResult =
            await NetworkService.PaymentService.processCashfree(
             paymentSessionId
            );
          console.log("cashfreeResult", cashfreeResult);

          this.loadingSpinner = true;
          setTimeout(async () => {
            await this.verifyPaymentStatus(result.order.data.order_id);
          }, 5000);
          // setTimeout(() => {
          //   this.loading = false;
          //   this.$router.push({
          //     name: "PaymentStatus",
          //     params: { order_id: result.order_id },
          //   });
          // }, 3000);
        } else {
          throw new Error("No payment session ID received from server");
        }
      } catch (error) {
        console.error("Error during payment gateway initiation:", error);
        const errorInfo = NetworkService.PaymentService.handleError?.(
          error
        ) || { message: error.message || "Unknown error" };
        this.$refs.toast.show(errorInfo.message, "error");
      }
    },
    async verifyPaymentStatus(orderId) {
  await NetworkService.PaymentService.verifyAndHandlePaymentStatus(orderId, this);
}
    //  async verifyPaymentStatus(orderId) {
    //   this.loading = false;
    //   try {
    //     const status = await NetworkService.PaymentService.verifyStatus(
    //       orderId
    //     );

    //     console.log("status..........", status);

    //     if (status === "SUCCESS") {
    //       this.$refs.toast.show("Payment successful", "success");
    //       this.loading = false;
    //       setTimeout(() => {
    //         this.$router.push({ name: "ThankYou" });
    //       }, 3000);
    //     } else if (status === "FAILED") {
    //       setTimeout(() => {
    //         this.loading = false;
    //         this.$refs.toast.show("Payment failed", "error");
    //       }, 3000);
    //     } else if (status === "PENDING") {
    //       setTimeout(() => {
    //         this.loading = false;
    //         this.$refs.toast.show("Payment is still pending", "info");
    //       }, 3000);
    //     } else {
    //       this.loading = false;
    //       this.$refs.toast.show("Payment Failed", "error");
    //     }
    //   } catch (error) {
    //     this.loading = false;
    //     const errorInfo = NetworkService.PaymentService.handleError(error);
    //     this.$refs.toast.show(errorInfo.message, "error");
    //   }
    // },
  },
};
</script>
